import React, { useState, useCallback, useEffect } from 'react';
import { Container, Card } from 'react-bootstrap';
import Helmet from 'react-helmet';

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import {
  faUpload,
} from '@fortawesome/pro-solid-svg-icons';

import LoginPageDecoration from '../components/LoginPageDecoration';
import PlugUploadModal from '../components/modals/PlugActionModals/PlugUploadModal';
import { ApiServiceExternalServerless } from '../xhr_libs';
import Loader from '../components/Loader';
import PlugUploadInstructionsModal from '../components/modals/PlugActionModals/PlugUploadInstructionModal';

const PAGE_TITLE = 'EnergyTracer File Upload';



function PlugUploadPublic(props) {
  const {
    match: {
      params: { token },
    },
  } = props;

  const [showInstructionsModal, setShowInstructionsModal] = useState(false);
  const [showPlugUploadModal, setShowPlugUploadModal] = useState(false);

  const [isLoading, setIsLoading] = useState(true)
  const [organization, setOrganization] = useState({});

  const getOrganizationDetails = useCallback(() => {
    setIsLoading(true)
    ApiServiceExternalServerless.get(`resource_info/organization/${token}`).then((res) => {
      setOrganization(res.data)
    }).finally(() => {
      setIsLoading(false)
    });
  }, [token]);

  useEffect(() => {
    getOrganizationDetails();
  }, [getOrganizationDetails]);



  return (
    <>
      <LoginPageDecoration />

      <Container
        style={{ padding: '0px', marginTop: '2em' }}
        className='et-unauth-container'
      >
        <Helmet>
          <title>{PAGE_TITLE}</title>
        </Helmet>
        {isLoading ? <Loader /> : (<>
          {organization.id ? (
            <Card style={{ textAlign: 'center' }}>
              <Card.Body><h4>EnergyTracer Utility Bill File Upload for {organization.name}</h4></Card.Body>
              <Card.Body> Please read all instructions before starting. Instructions can be found <div style={{ display: 'inline-block', textDecoration: 'underline', 'cursor': 'pointer' }} onClick={() => { setShowInstructionsModal(true) }}>here</div>. </Card.Body>
              <Card.Body> Click here to begin:  <FontAwesomeIcon
                style={{
                  fontSize: '20px',
                  margin: '0 0.35em',
                  verticalAlign: 'text-bottom',
                  cursor: 'pointer',
                  color: 'var(--et_tab_grey)',

                }}
                icon={faUpload}
                title={'Upload Files'}
                onClick={() => setShowPlugUploadModal(true)}
              /></Card.Body> </Card>) : (
            <Card style={{ textAlign: 'center' }}>
              <Card.Body>
                Invalid Organization. Please reach out to an administrator for assistance.
              </Card.Body>
            </Card>
          )}</>)}



      </Container>
      <PlugUploadModal
        show={showPlugUploadModal}
        onHide={() => {
          setShowPlugUploadModal(false);
        }}
        organizationUUID={token}
      />
      <PlugUploadInstructionsModal
        show={showInstructionsModal}
        onHide={() => { setShowInstructionsModal(false) }}
      />
    </>
  );
}

export default PlugUploadPublic;
